import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const STRICT_EMAIL_REGEX = /^[a-z0-9](?:[a-z0-9._%+-]{0,62}[a-z0-9])?@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i;

// Custom validator function
export function forbidUppercase(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const hasUppercase = /[A-Z]/.test(control.value);
    return hasUppercase ? { 'forbidUppercase': { value: control.value } } : null;
  };
}

export function strictEmail(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value !== 'string') {
      return { email: true };
    }

    const normalizedValue = value.trim();
    const hasWhitespace = /\s/.test(normalizedValue);

    if (normalizedValue !== value || hasWhitespace) {
      return { email: true };
    }

    return STRICT_EMAIL_REGEX.test(normalizedValue) ? null : { email: true };
  };
}
